// src/App.jsx
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import EarlyAccessBanner from "./components/EarlyAccessBanner";
import AppRoutes from "./routes";
import { AuthProvider } from "./context/AuthContext";

function AppShell() {
  const location = useLocation();

  const hideNavbarRoutes = new Set([
    "/reset-password",
    "/update-password",
    "/forgot-password",
  ]);

  const hideNavbar = hideNavbarRoutes.has(location.pathname);

  return (
    <>
      {!hideNavbar && <EarlyAccessBanner />}
      {!hideNavbar && <Navbar />}
      <AppRoutes />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </Router>
  );
}